import React from 'react';
import PropTypes from 'prop-types';

import { Collapse, TableCell, TableRow } from '@mui/material';

import OnDeleteIcon from '../../../../icons/OnDeleteIcon';
import OnEditIcon from '../../../../icons/OnEditIcon';
import { formatDate } from '../../../../utils/dateFunctions';

import SignPostingRowDetails from './SignPostingRowDetails';

import table from '../../../../commonStyles/tables.module.css';

const styles = {
    paddingBottom: 0,
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
    borderTop: 'none',
    borderBottom: 'none'
};

const SignPostingRow = ({
    row,
    isDisabled,
    isDeleteDisabled,
    onEdit,
    onDelete,
    toggleDropdown,
    openId
}) => {

    const onToggleDropdown = () => toggleDropdown(openId === row.id ? '' : row.id);

    return (
        <>
            <TableRow
                key={row.id}
                hover
                className={`${table.tableRowStripes} ${table.canOpen}`}
                onClick={onToggleDropdown}>
                <TableCell>{formatDate(row.date)}</TableCell>
                <TableCell>{row.organisation}</TableCell>
                <TableCell>{row.type}</TableCell>
                <TableCell align="right" id="editIcon">
                    <OnEditIcon
                        onEdit={(e) => onEdit(e, row)}
                        active={!isDisabled}
                    />
                </TableCell>
                <TableCell align="right">
                    <OnDeleteIcon
                        onDelete={() => onDelete(row)}
                        active={!isDeleteDisabled}
                    />
                </TableCell>
            </TableRow>

            <TableRow>
                <TableCell style={styles} colSpan={5}>
                    <Collapse in={openId === row.id} timeout="auto" unmountOnExit>
                        <SignPostingRowDetails row={row} onClose={onToggleDropdown} />
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

SignPostingRow.propTypes = {
    row: PropTypes.object,
    isDisabled: PropTypes.bool,
    isDeleteDisabled: PropTypes.bool,
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    toggleDropdown: PropTypes.func,
    openId: PropTypes.string
};

export default SignPostingRow;
